import { render, staticRenderFns } from "./ApprovalsTable.vue?vue&type=template&id=70e07f07&scoped=true"
import script from "./ApprovalsTable.vue?vue&type=script&lang=ts"
export * from "./ApprovalsTable.vue?vue&type=script&lang=ts"
import style0 from "./ApprovalsTable.vue?vue&type=style&index=0&id=70e07f07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e07f07",
  null
  
)

export default component.exports